@if (loading) {
<div class="as-fixed-loader">
  <ng-lottie width="150px" height="150px" [options]="options"> </ng-lottie>
  <mat-label class="as-roboto-slab as-font-bold as-font-20 as-font-red">
    {{ 'GENERAL.loading' | translate }}...
  </mat-label>
</div>
}
<div class="product">
  <div class="as-img-container">
    <div class="img-cont">
      <img
        [defaultImage]="defaultImage"
        [lazyLoad]="product.image_url"
        [src]=""
        onerror="src = 'assets/images/default-product.svg';"
        alt="Product list image"
      />
      @if (product.price !== product.regular_price) {
      <div class="as-product-discount">
        <mat-label class="as-font as-font-white as-font-13">
          -{{ discount }}%
        </mat-label>
      </div>
      }
    </div>
    <a
      [routerLink]="product.product_url"
      class="as-font-blackish as-font-14 as-font as-pointer name"
    >
      {{ product.description | titlecase }}</a
    >
  </div>
  <div class="price-cont">
    <p
      class="as-font as-font-semibold as-font-16"
      [ngClass]="
        product.price === product.regular_price
          ? 'as-font-black-gray'
          : 'as-font-warn'
      "
    >
      {{ product.price | currency : '$' }}
    </p>
    @if (product.price !== product.regular_price) {
    <p class="as-font as-font-16 as-font-line-through">
      {{ product.regular_price | currency : '$' }}
    </p>
    }
  </div>
  <div class="as-display-details">
    <div class="as-quantity-container">
      @if (!productAdded) { @if (product?.stock > 0 && !addingProduct) {
      <button
        style="width: 170px"
        mat-stroked-button
        [ngClass]="!displayProductQuantity ? 'mt-27' : 'mt-16'"
        class="as-product-add"
        color="accent"
        (click)="displayDetailsBeforeAdding()"
      >
        <mat-label class="as-font">
          {{ 'GENERAL.add' | translate }}
        </mat-label>
      </button>
      } @if (addingProduct) {
      <div class="as-spinner-green as-row as-justify-center as-spinner-width">
        <mat-spinner [diameter]="25"></mat-spinner>
      </div>
      } @if ( (product?.stock === null || product?.stock === undefined ||
      product?.stock <= 0) && !addingProduct ) {
      <button
        mat-stroked-button
        style="width: 170px"
        [ngClass]="!displayProductQuantity ? 'mt-27' : 'mt-16'"
        class="as-product-unavailable"
        [disabled]="true"
      >
        <mat-label class="as-font">
          {{ 'PURCHASE.off' | translate }}
        </mat-label>
      </button>
      } } @else { @if (productAdded) {
      <div class="as-display-details">
        <div class="as-quantity-container">
          @if (productTypeQuantity === 'pza') {
          <div class="as-quantity">
            <button mat-button color="accent" (click)="subtract()">
              <mat-icon svgIcon="ic-minus"></mat-icon>
            </button>
            <div class="input-value">
              <input
                mask="000000"
                suffix=" pz"
                (blur)="changePieces(productQuantity)"
                [(ngModel)]="productQuantity"
                type="text"
                readonly
              />
            </div>
            <button
              [disabled]="
                ((madurityList.length > 0 || sliceList.length > 0) &&
                  !madurity.value &&
                  !slice.value) ||
                (productType === 'pza' && product?.stock <= productQuantity) ||
                (productType === 'pza-grammage' &&
                  product?.stock <= productQuantity * product?.weight)
              "
              mat-button
              color="accent"
              (click)="add()"
            >
              <mat-icon svgIcon="ic-plus"></mat-icon>
            </button>
          </div>
          } @else {
          <div class="as-quantity">
            <button mat-button color="accent" (click)="subtract()">
              <mat-icon svgIcon="ic-minus"></mat-icon>
            </button>
            <div class="input-value">
              <input
                mask="000000"
                suffix=" gr"
                (blur)="changeGrams(productQuantityGrams)"
                [(ngModel)]="productQuantityGrams"
                type="text"
                readonly
              />
            </div>
            <button
              [disabled]="
                ((madurityList.length > 0 || sliceList.length > 0) &&
                  !madurity.value &&
                  !slice.value) ||
                product?.stock <= productQuantityGrams / 1000
              "
              mat-button
              color="accent"
              (click)="add()"
            >
              <mat-icon svgIcon="ic-plus"></mat-icon>
            </button>
          </div>
          }
          <ng-template #grams>
            <div class="as-quantity">
              <button mat-button color="accent" (click)="subtract()">
                <mat-icon svgIcon="ic-minus"></mat-icon>
              </button>
              <div class="input-value">
                <input
                  mask="000000"
                  suffix=" gr"
                  (blur)="changeGrams(productQuantityGrams)"
                  [(ngModel)]="productQuantityGrams"
                  type="text"
                  readonly
                />
              </div>
              <button
                [disabled]="
                  ((madurityList.length > 0 || sliceList.length > 0) &&
                    !madurity.value &&
                    !slice.value) ||
                  product?.stock <= productQuantityGrams / 1000
                "
                mat-button
                color="accent"
                (click)="add()"
              >
                <mat-icon svgIcon="ic-plus"></mat-icon>
              </button>
            </div>
          </ng-template>
        </div>
        @if (productType === 'pza-grammage') {
        <div class="as-switch-quantity as-mb-1em">
          <button
            mat-flat-button
            class="as-type-select"
            [class.as-active]="productTypeQuantity === 'pza'"
            (click)="onSwitchTypeQuanity('pza')"
          >
            <mat-label class="as-font-10">
              {{ 'GENERAL.piece' | translate }}
            </mat-label>
          </button>
          <button
            mat-flat-button
            class="as-type-select"
            [class.as-active]="productTypeQuantity === 'grammage'"
            (click)="onSwitchTypeQuanity('grammage')"
          >
            <mat-label class="as-font-10">
              {{ 'GENERAL.grams' | translate }}
            </mat-label>
          </button>
        </div>
        } @if (madurityList.length > 0) {
        <mat-select
          placeholder="{{ 'GENERAL.selectMadurity' | translate }}"
          [formControl]="madurity"
        >
          @for (option of madurityList; track option) {
          <mat-option value="{{ option }}">{{ option }}</mat-option>
          }
        </mat-select>
        } @if (sliceList.length > 0) {
        <mat-select [formControl]="slice" placeholder="Rebanada">
          @for (item of sliceList; track item) {
          <mat-option [value]="item"> {{ item }}</mat-option>
          }
        </mat-select>
        } @if (!addingProduct) {
        <button
          [disabled]="
            ((madurityList.length > 0 || sliceList.length > 0) &&
              !madurity.value &&
              !slice.value) ||
            (productTypeQuantity === 'pza' &&
              productType === 'pza' &&
              product?.stock < productQuantity) ||
            (productTypeQuantity === 'pza' &&
              productType === 'pza-grammage' &&
              product?.stock < productQuantity * product?.weight) ||
            (productTypeQuantity !== 'pza' &&
              product?.stock < productQuantityGrams / 1000)
          "
          mat-stroked-button
          class="as-product-add-details"
          color="accent"
          (click)="onAddingToCart()"
        >
          <mat-label class="as-font">
            {{
              !productAdded
                ? ('GENERAL.add' | translate)
                : ('GENERAL.update' | translate)
            }}
          </mat-label>
        </button>
        }
      </div>
      } }
      <div class="as-quantity-details">
        @if (!product.public) {
        <div class="as-trash-container">
          <mat-icon
            (click)="removeProductFromList(product.sku)"
            class="as-pointer"
            svgIcon="ic-trash"
          >
          </mat-icon>
        </div>
        }
      </div>
    </div>
  </div>
</div>
